import React, { useEffect, useState } from "react";
import { withFirebase } from "../../firebase";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import PickupControl from "./pickupControl";

const PickupControlContainer = (props) => {
	const { t } = useTranslation();
	const cities = useSelector((state) => state.shops.shops);
	const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
	const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
	const isDebug = JSON.parse(localStorage.getItem("isDebug"));
	const deliveryTerminals =
		cities?.[currentCity]?.brands?.[currentBrand]?.deliveryTerminals;
	const terminalsPath = `${
		isDebug ? "debug" : ""
	}/settings/city/${currentCity}/brands/${currentBrand}/deliveryTerminals`;

	const [terminals, setTerminals] = useState(deliveryTerminals || []);

	useEffect(() => {
		setTerminals(deliveryTerminals || []);
	}, [deliveryTerminals, currentCity, currentBrand]);

	const onSubmit = () => {
		const isValidTerminals = terminals.some((item) => item?.isActive === true);
		if (isValidTerminals) {
			props.firebase.bd
				.ref(terminalsPath)
				.update(terminals)
				.then(() => {
					alert(t("buttons.done"));
				})
				.catch((error) => {
					console.error("Error updating terminals:", error);
					alert(t("pickupControl.error"));
				});
		} else {
			alert(t("pickupControl.minActiveTerminal"));
		}
	};

	return (
		<div>
			{terminals && (
				<PickupControl
					terminals={terminals}
					setTerminals={setTerminals}
					saveData={onSubmit}
				/>
			)}
		</div>
	);
};

export default withRouter(withFirebase(PickupControlContainer));
